import { CSSProperties, ReactNode } from 'react';

import { ButtonType, Size } from 'coreOld/enums';

import { ButtonWrapper } from './buttonStyle';

interface IProps {
  id?: string;
  onClick?;
  onMouseDown?;
  disabled?: boolean;
  size?: Size;
  btnType?: ButtonType;
  children?: ReactNode;
  style?: CSSProperties;
  hasMarginRight?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const ButtonView = ({
  id,
  onClick,
  onMouseDown,
  disabled,
  size,
  btnType = ButtonType.ACTION,
  children,
  style,
  hasMarginRight = false,
  fullWidth = true,
  fullHeight = false,
}: IProps) => {
  return (
    <ButtonWrapper
      id={id}
      onClick={onClick}
      onMouseDown={onMouseDown}
      type="button"
      disabled={disabled}
      size={size}
      btnType={btnType}
      style={style}
      hasMarginRight={hasMarginRight}
      fullWidth={fullWidth}
      fullHeight={fullHeight}
    >
      {children}
    </ButtonWrapper>
  );
};

export default ButtonView;
